import { UserAccessStats } from '#server/models';
export interface UserAccessSummaryProps {
  userAccessStats: UserAccessStats;
}
export const UserAccessSummary = ({ userAccessStats }: UserAccessSummaryProps) => {
  return (
    <div className="ml-4 mt-4 space-y-4">
      <h3 className="text-sh3">User access</h3>
      <div className="space-y-2">
        <div className="flex">
          <span className="w-56 text-b3">Total number of users:</span>
          <span className="text-b3">{userAccessStats.noOfUsers}</span>
        </div>
        <div className="flex">
          <span className="w-56 text-b3">Read only access:</span>
          <span className="text-b3">{userAccessStats.noOfReadAccess}</span>
        </div>
        <div className="flex">
          <span className="w-56 text-b3">Read / Write access:</span>
          <span className="text-b3">{userAccessStats.noOfReadWriteAccess}</span>
        </div>
        <div className="flex">
          <span className="w-56 text-b3">Report access:</span>
          <span className="text-b3">{userAccessStats.noOfReportAccess}</span>
        </div>
      </div>
    </div>
  );
};
